<template>
  <v-dialog
    :value="show"
    fullscreen
    transition="dialog-bottom-transition"
    @input="handleDialogInput"
  >
    <v-card rounded="0">
      <Toolbar title="Edit Dynamic Data Group" @close="requestClose" color="systemPrimary" />
      <v-card-text class="px-md-10 py-6">
        <InformGroupEditor
          v-if="show"
          :key="editorKey"
          :clientId="clientId"
          :initialGroupName="initialGroupName"
          :initialGroupRuleQuery="initialGroupRuleQuery"
          :initialUserIdPath="initialUserIdPath"
          submitLabel="Save"
          @submit="handleSubmit"
          @cancel="requestClose"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Toolbar from "@/components/generic/Toolbar.vue";
import InformGroupEditor from "@/components/groups/InformGroupEditor.vue";

export default {
  name: "EditInformGroupDialog",
  components: {
    Toolbar,
    InformGroupEditor,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: [Number, String],
      default: null,
    },
    groupData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editorKey: 0,
    };
  },
  computed: {
    initialGroupName() {
      return (this.groupData && this.groupData.groupDisplayName) || "";
    },
    initialUserIdPath() {
      const informQuery = this.groupData && this.groupData.informQuery;
      return (informQuery && informQuery.userIdPath) || "";
    },
    initialGroupRuleQuery() {
      const informQuery = this.groupData && this.groupData.informQuery;
      const query = informQuery && informQuery.query;
      if (query == null) return "";
      return typeof query === "string" ? query : JSON.stringify(query, null, 2);
    },
  },
  methods: {
    handleSubmit(payload) {
      this.$emit("update", {
        groupId: this.groupData.groupId,
        ...payload,
      });
    },
    requestClose() {
      this.$emit("close");
    },
    handleDialogInput(value) {
      if (!value) {
        this.requestClose();
      } else {
        this.$emit("update:show", value);
      }
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.editorKey += 1;
      }
    },
  },
};
</script>

<style scoped>
.v-card__text {
  padding-left: 160px !important;
  padding-right: 160px !important;
}
</style>
